import router from 'platfi-service-router';

export default router.init({ BASE_URL: window._env_.API_DOMAIN });
